import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import { point } from '@turf/helpers'

const closeRing = ring => {
  if (!Array.isArray(ring) || ring.length < 3) return ring
  const first = ring[0]
  const last = ring[ring.length - 1]
  if (first[0] !== last[0] || first[1] !== last[1]) {
    return [...ring, first]
  }
  return ring
}

const normalizeGeometry = geometry => {
  if (!geometry || !geometry.coordinates) return null
  if (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') return geometry

  const coords = geometry.coordinates
  if (!Array.isArray(coords) || coords.length === 0) return null

  if (typeof coords[0][0] === 'number') {
    return { type: 'Polygon', coordinates: [closeRing(coords)] }
  }
  if (Array.isArray(coords[0][0]) && typeof coords[0][0][0] === 'number') {
    return { type: 'Polygon', coordinates: coords.map(closeRing) }
  }
  if (Array.isArray(coords[0][0][0]) && typeof coords[0][0][0][0] === 'number') {
    return { type: 'MultiPolygon', coordinates: coords }
  }
  return geometry.type ? geometry : null
}

const extractFeatures = geojson => {
  if (!geojson || !geojson.type) return null
  switch (geojson.type) {
    case 'FeatureCollection':
      return geojson.features || []
    case 'Feature':
      return [geojson]
    case 'Polygon':
    case 'MultiPolygon':
      return [{ type: 'Feature', geometry: geojson, properties: {} }]
    case 'GeometryCollection':
      return (geojson.geometries || []).map(g => ({
        type: 'Feature',
        geometry: g,
        properties: {},
      }))
    default:
      return null
  }
}

export const isPointInBoundary = (coordinates, boundary) => {
  if (!boundary) return false
  try {
    const pt = point(coordinates)
    const features = extractFeatures(boundary)
    if (!features || features.length === 0) return false

    return features.some(feature => {
      try {
        if (!feature.geometry || !feature.geometry.coordinates) return false
        const normalized = normalizeGeometry(feature.geometry)
        if (!normalized) return false
        return booleanPointInPolygon(pt, {
          type: 'Feature',
          geometry: normalized,
          properties: feature.properties || {},
        })
      } catch {
        return false
      }
    })
  } catch {
    return false
  }
}

